import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/* Small one-tap install icon. Native prompt when the browser allows it, short help otherwise. */
export default function InstallAppButton({ className = "" }) {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const ios = /iPhone|iPad|iPod/i.test(navigator.userAgent || "");

  useEffect(() => {
    if (window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone) { setInstalled(true); return; }
    const handler = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", handler); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (installed) return null;
  const click = async () => {
    if (deferred) {
      deferred.prompt();
      try { await deferred.userChoice; } catch { /* noop */ }
      setDeferred(null);
      return;
    }
    setShowHelp(true);
  };
  return (
    <>
      <button onClick={click} data-testid="install-app-btn" title="Install Eventom app" aria-label="Install Eventom app"
        className={`inline-flex items-center justify-center w-9 h-9 rounded-full bg-lime/15 text-lime border border-lime/40 hover:bg-lime hover:text-ink transition-colors ${className}`}>
        <Download className="w-4 h-4" />
      </button>
      {showHelp && (
        <div className="fixed inset-0 z-[80] bg-bg/85 flex items-center justify-center p-4" onClick={() => setShowHelp(false)}>
          <div className="glass p-6 max-w-xs w-full" onClick={(e) => e.stopPropagation()} data-testid="install-help-modal">
            <div className="flex items-center justify-between mb-3">
              <div className="font-display text-2xl">Install Eventom</div>
              <button onClick={() => setShowHelp(false)} data-testid="install-help-close" className="icon-circle !w-7 !h-7 !rounded-full"><X className="w-3.5 h-3.5" /></button>
            </div>
            {ios ? (
              <ol className="text-sm text-text/85 space-y-2 list-decimal list-inside">
                <li>Tap the <span className="font-bold">Share</span> button in Safari</li>
                <li>Choose <span className="font-bold">Add to Home Screen</span></li>
                <li>Tap <span className="font-bold">Add</span> — done</li>
              </ol>
            ) : (
              <ol className="text-sm text-text/85 space-y-2 list-decimal list-inside">
                <li>Open the browser menu (<span className="font-bold">⋮</span>)</li>
                <li>Tap <span className="font-bold">Install app</span></li>
                <li>Confirm — Eventom installs like a native app</li>
              </ol>
            )}
          </div>
        </div>
      )}
    </>
  );
}
